"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsableColorsAgainstBackground = exports.ensureTextVisibleInBlock = exports.lumaDiff = void 0;
var colord_1 = require("colord");
var a11y_1 = __importDefault(require("colord/plugins/a11y"));
var names_1 = __importDefault(require("colord/plugins/names"));
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
(0, colord_1.extend)([a11y_1.default, names_1.default]);
var CONTRAST_THRESHOLD = 3;
var ColorStatus;
(function (ColorStatus) {
    ColorStatus["Unusable"] = "unusable";
    ColorStatus["Used"] = "used";
    ColorStatus["Available"] = "available";
})(ColorStatus || (ColorStatus = {}));
var lumaDiff = function (backgroundColor, foregoundColor) {
    return (0, colord_1.colord)(foregoundColor).contrast(backgroundColor);
};
exports.lumaDiff = lumaDiff;
var getAllColorsWithStatus = function (brandColors, backgroundColor) {
    var availableColors = __spreadArray(__spreadArray([], __read(brandColors), false), __read(DefaultColors_1.allDefaultColors), false);
    var colorsWithStatus = availableColors.map(function (c) { return (__assign(__assign({}, c), { status: ColorStatus.Available })); });
    return colorsWithStatus.map(function (c) {
        if ((0, exports.lumaDiff)(backgroundColor, c.value) < CONTRAST_THRESHOLD) {
            return __assign(__assign({}, c), { status: ColorStatus.Unusable });
        }
        return c;
    });
};
var getTheFirstAvailableColor = function (colors) {
    return colors.find(function (c) { return c.status === ColorStatus.Available; });
};
var getTheFirstUsableColor = function (colors) {
    return colors.find(function (c) { return c.status !== ColorStatus.Unusable; });
};
var getTextTypesThatUseAColor = function (blockStyle, themeIndex) {
    var _a, _b, _c;
    var result = [];
    if (((_a = blockStyle.h1) === null || _a === void 0 ? void 0 : _a.color.themeIndex) === themeIndex) {
        result.push("h1");
    }
    if (((_b = blockStyle.h2) === null || _b === void 0 ? void 0 : _b.color.themeIndex) === themeIndex) {
        result.push("h2");
    }
    if (((_c = blockStyle.p) === null || _c === void 0 ? void 0 : _c.color.themeIndex) === themeIndex) {
        result.push("p");
    }
    return result;
};
var findBetterColorsForText = function (blockStyle, colorsWithStatus) {
    var e_1, _a;
    var _b;
    var colorsToUpdate = {};
    var allThemeIndexes = __spreadArray(__spreadArray([], __read(Array(7).keys()), false), __read(DefaultColors_1.allDefaultColors.map(function (c) { return c.themeIndex; })), false);
    var _loop_1 = function (themeIndex) {
        var e_2, _c;
        var textTypesToUpdate = getTextTypesThatUseAColor(blockStyle, themeIndex);
        if (textTypesToUpdate.length > 0) {
            var matchedColor = colorsWithStatus.find(function (c) { return c.themeIndex === themeIndex; });
            if ((matchedColor === null || matchedColor === void 0 ? void 0 : matchedColor.status) === ColorStatus.Available) {
                matchedColor.status = ColorStatus.Used;
            }
            else {
                var newColor_1 = (_b = getTheFirstAvailableColor(colorsWithStatus)) !== null && _b !== void 0 ? _b : getTheFirstUsableColor(colorsWithStatus);
                if (!!newColor_1) {
                    try {
                        for (var textTypesToUpdate_1 = (e_2 = void 0, __values(textTypesToUpdate)), textTypesToUpdate_1_1 = textTypesToUpdate_1.next(); !textTypesToUpdate_1_1.done; textTypesToUpdate_1_1 = textTypesToUpdate_1.next()) {
                            var textType = textTypesToUpdate_1_1.value;
                            colorsToUpdate[textType] = { themeIndex: newColor_1.themeIndex, abs: newColor_1.value };
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (textTypesToUpdate_1_1 && !textTypesToUpdate_1_1.done && (_c = textTypesToUpdate_1.return)) _c.call(textTypesToUpdate_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    colorsWithStatus.forEach(function (c) {
                        if (c.themeIndex === newColor_1.themeIndex) {
                            c.status = ColorStatus.Used;
                        }
                    });
                }
            }
        }
    };
    try {
        for (var allThemeIndexes_1 = __values(allThemeIndexes), allThemeIndexes_1_1 = allThemeIndexes_1.next(); !allThemeIndexes_1_1.done; allThemeIndexes_1_1 = allThemeIndexes_1.next()) {
            var themeIndex = allThemeIndexes_1_1.value;
            _loop_1(themeIndex);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (allThemeIndexes_1_1 && !allThemeIndexes_1_1.done && (_a = allThemeIndexes_1.return)) _a.call(allThemeIndexes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return colorsToUpdate;
};
var updateBlockWithNewColors = function (blockStyle, colorsToUpdate) {
    if (!!colorsToUpdate.h1 && !!blockStyle.h1) {
        blockStyle.h1.color = colorsToUpdate.h1;
    }
    if (!!colorsToUpdate.h2 && !!blockStyle.h2) {
        blockStyle.h2.color = colorsToUpdate.h2;
    }
    if (!!colorsToUpdate.p && !!blockStyle.p) {
        blockStyle.p.color = colorsToUpdate.p;
    }
};
var ensureTextVisibleInBlock = function (brandColors, block) {
    var _a = block.style, h1 = _a.h1, h2 = _a.h2, p = _a.p, background = _a.background;
    if (!h1 || !h2 || !p) {
        return;
    }
    var brandColorObjs = (0, ColorUtils_1.assembleBrandColors)(brandColors);
    if (block.type === commonTypes_1.BlockType.Splash) {
        background.themeIndex = DefaultColors_1.DEFAULT_WHITE.themeIndex;
        background.abs = DefaultColors_1.DEFAULT_WHITE.value;
    }
    else {
        if (background.themeIndex != null && background.themeIndex >= 0) {
            var matchedColor = brandColorObjs.find(function (c) { return c.themeIndex === background.themeIndex; });
            if (!matchedColor) {
                background.themeIndex = 0;
                background.abs = brandColorObjs[0].value;
            }
            else {
                background.abs = matchedColor.value;
            }
        }
    }
    var colorsWithStatus = getAllColorsWithStatus(brandColorObjs, background.abs);
    var colorsToUpdate = findBetterColorsForText(block.style, colorsWithStatus);
    updateBlockWithNewColors(block.style, colorsToUpdate);
};
exports.ensureTextVisibleInBlock = ensureTextVisibleInBlock;
var getUsableColorsAgainstBackground = function (colors, backgroundColor) {
    return colors.filter(function (c) { return (0, exports.lumaDiff)(backgroundColor, c) >= CONTRAST_THRESHOLD; });
};
exports.getUsableColorsAgainstBackground = getUsableColorsAgainstBackground;
